// 处方路由
export default [{
    path: '/recipe/list',
    name: 'recipeList',
    component: () => import('@/views/recipe/list')
}, 
// 老版本迁移--我的处方
{
    path: '/myPrescription',
    name: 'myPrescription',
    component: () => import('@/views/recipe/list')
},
{
    path: '/recipe/detail/:id/:type?',
    name: 'recipeDetail',
    component: () => import('@/views/recipe/detail')
},{
    path: '/recipe/search',
    name: 'recipeSearch',
    component: () => import('@/views/recipe/search')
}]



// WEBPACK FOOTER //
// ./src/router/recipe.js